import { transient } from "aurelia-framework";

@transient()
export class MessageWell {
}